var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTailwindcss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 64,
    viewBox: "0 0 106 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_96_5051)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_96_5051",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 106,
    height: 63
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.688477 0H105.416V62.8364H0.688477V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_96_5051)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.0521 0C39.0885 0 30.3612 6.98182 26.8703 20.9455C32.1067 13.9636 38.2158 11.3455 45.1976 13.0909C49.1811 14.0858 52.0281 16.9775 55.1796 20.1755C60.3132 25.3867 66.2555 31.4182 79.2339 31.4182C93.1976 31.4182 101.925 24.4364 105.416 10.4727C100.179 17.4545 94.0703 20.0727 87.0885 18.3273C83.105 17.3324 80.2579 14.4407 77.1064 11.2427C71.9728 6.03151 66.0305 0 53.0521 0ZM26.8703 31.4182C12.9067 31.4182 4.17939 38.4 0.688477 52.3636C5.92484 45.3818 12.0339 42.7636 19.0157 44.5091C22.9993 45.5059 25.8463 48.3956 28.9978 51.5937C34.1314 56.8048 40.0737 62.8364 53.0521 62.8364C67.0157 62.8364 75.743 55.8545 79.2339 41.8909C73.9976 48.8727 67.8885 51.4909 60.9067 49.7455C56.9231 48.7505 54.0761 45.8589 50.9246 42.6608C45.791 37.4497 39.8487 31.4182 26.8703 31.4182Z",
    fill: "#38BDF8"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_96_5051"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 104.727,
    height: 64,
    fill: "white",
    transform: "translate(0.688477)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTailwindcss);
export default __webpack_public_path__ + "static/media/icon-tailwindcss.f2fdf61eb84bdc3fe6fd746c0b6b9a06.svg";
export { ForwardRef as ReactComponent };